<template>
    <Transition name="modal">
        <div v-modal-focus v-if="isModalVisible" :id="modalId" class="modal-mask">
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">
                            <span>{{ modalTitle }}</span>
                   </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                       <p>{{ modalMessage }}</p>
                     </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        <button class="btn btn-primary m-3 modal-button" @click="performAction">
                            OK
                        </button>
                        <button class="btn btn-dark m-3 modal-button" @click="cancelAction">
                            Cancel
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref, toRefs } from 'vue';

let props = defineProps({
    modalId: String,
    modalTitle: String,
    modalMessage: String,
    isModalVisible: Boolean,
    performActionCallback: Function
});

const emit = defineEmits(['cancel-action', 'perform-action', 'close-modal']);

const { isModalVisible } = toRefs(props);

const closeModal = () => {
    emit('close-modal');
};

const cancelAction = () => {
    emit('cancel-action');
    closeModal();
};

const performAction = async () => {
    emit('perform-action');
    if (props.performActionCallback) {
        props.performActionCallback();
    }
    closeModal();
};
</script>

<style scoped>
     .modal-mask {
         position: fixed;
         z-index: 9998;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         background-color: rgba(0, 0, 0, 0.5);
         display: flex;
         align-items: center;
         justify-content: center;
         transition: opacity 0.3s ease;
     }

     .modal-container {
         width: 300px;
         margin: 0;
         padding: 20px 30px;
         background-color: #fff;
         border-radius: 2px;
         box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
         transition: all 0.3s ease;
     }

     .modal-header, .modal-footer {
         padding: 10px 0;
         border-bottom: 1px solid #dee2e6;
     }

     .modal-header:last-child {
         border-bottom: none;
     }

     .modal-body {
         margin: 20px 0;
     }

     .modal-enter-active, .modal-leave-active {
         transition: opacity 0.5s ease;
     }

     .modal-enter-from, .modal-leave-to {
         opacity: 0;
     }

     .modal-enter-from .modal-container, .modal-leave-to .modal-container {
         transform: scale(1.1);
     }

     .modal-button {
        width: 80px;
     }
 

</style>
